import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 113 113"
      height={props.height ? props.height : "22px "}
    >
      <path
        className={props.pathClass ? props.pathClass : "black"}
        d="M658.759 1804.31c-11.942-11.94-11.942-31.3 0-43.25 47.455-47.45 156.524-156.52 156.524-156.52a4.162 4.162 0 015.893 0l36.232 36.23a4.164 4.164 0 010 5.89l-136.022 136.03 317.434 317.43c1.62 1.62 1.62 4.26 0 5.89l-36.24 36.23a4.157 4.157 0 01-5.889 0s-260.267-260.26-337.932-337.93z"
        transform="matrix(0 -.1308 .1308 0 -188.661 165.94)"
      ></path>
      <path
        fill="none"
        d="M7743.43 11233.1H7802.857V11302.999H7743.43z"
        transform="matrix(1.89741 0 0 1.60953 -14692.4 -18080)"
      ></path>
    </svg>
  );
}

export default Icon;
